<template>
  <div
    v-if="show && highway"
    class="highway-hover-tooltip"
    :style="tooltipStyle"
  >
    <div class="highway-tooltip-content">
      <div class="highway-tooltip-header">
        {{ highway.sign_rte || highway.road_name }}
      </div>
      
      <div class="highway-tooltip-table">
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Road Name</span>
          <span class="highway-tooltip-value">{{ highway.road_name || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Class</span>
          <span class="highway-tooltip-value">{{ highway.class || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Class Description</span>
          <span class="highway-tooltip-value">{{ highway.class_desc || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Sign Route</span>
          <span class="highway-tooltip-value">{{ highway.sign_rte || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Route Type</span>
          <span class="highway-tooltip-value">{{ highway.rte_type || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Route Number</span>
          <span class="highway-tooltip-value">{{ highway.rte_number || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">State</span>
          <span class="highway-tooltip-value">{{ highway.state || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">State FIPS</span>
          <span class="highway-tooltip-value">{{ highway.stfips || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">County FIPS</span>
          <span class="highway-tooltip-value">{{ highway.ctfips || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Urban Code</span>
          <span class="highway-tooltip-value">{{ highway.urban_code || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Total Tons</span>
          <span class="highway-tooltip-value">{{ formatNumber(highway.TOT_Tons_1) }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Route ID</span>
          <span class="highway-tooltip-value">{{ highway.OBJECTID || '-' }}</span>
        </div>
        
        <div class="highway-tooltip-row">
          <span class="highway-tooltip-label">Length (Miles)</span>
          <span class="highway-tooltip-value">{{ formatLength(highway.GEOD_LEN) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HighwayHoverTooltip',
  
  props: {
    show: {
      type: Boolean,
      default: false
    },
    highway: {
      type: Object,
      default: null
    },
    tooltipStyle: {
      type: Object,
      default: () => ({})
    }
  },
  
  methods: {
    formatNumber(value) {
      if (!value) return '-';
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    
    formatLength(value) {
      if (!value) return '-';
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toFixed(2);
    }
  }
};
</script>
